/* eslint-disable import/no-extraneous-dependencies */
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import PageCommonHandler from '../components/PageCommonHandler';
import DashboardSection from '../app/dashboard/DashboardSection';
import MemberList from '../app/member/MemberList';
import MemberCreate from '../app/member/MemberCreate';
import MemberCollection from '../app/member/MemberCollection';
import IncomeInfo from '../app/income/IncomeInfo';
import DailyExpenseInfo from '../app/expense/DailyExpenseInfo';
import LocalInvestInfo from '../app/invest/LocalInvestInfo';
import OtherInvestInfo from '../app/invest/OtherInvestInfo';
import ProfitLossDisbursementInfo from '../app/profitloss/ProfitLossDisbursementInfo';
import BorrowerInfo from '../app/invest/BorrowerInfo';
import FinanceTransactionInfo from '../app/finance/FinanceTransactionInfo';

function RouteHandler() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<PageCommonHandler />}>
                    <Route path="/" element={<DashboardSection />} />
                    <Route path="member/list" element={<MemberList />} />
                    <Route path="member/create" element={<MemberCreate />} />
                    <Route path="member/collection" element={<MemberCollection />} />
                    <Route path="income" element={<IncomeInfo />} />
                    <Route path="expense/daily" element={<DailyExpenseInfo />} />
                    <Route path="invest/borrower" element={<BorrowerInfo />} />
                    <Route path="invest/local" element={<LocalInvestInfo />} />
                    <Route path="invest/other" element={<OtherInvestInfo />} />
                    <Route path="profit-loss/disbursement" element={<ProfitLossDisbursementInfo />} />
                    <Route path="finance/transaction" element={<FinanceTransactionInfo />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default RouteHandler;
